<div>
    <img src="../assets/Benhausen.jpg" alt="Benshausen" style="width: 66%; height: 480px; min-height: 66%;">
<!--
    width: 66%;
    height: 480px;
    min-height: 66%;
-->
</div>
